module.exports = __webpack_public_path__ + "img/format-list-group.9d14e269.svg";